















































































































































































































































































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class HelpItemEtas extends Vue {
  show = true
}
